import {MAX_NESTED_GROUPS} from './filter-constants'

export const Strings = {
  filterInvalid: (number: number) => `Filter contains ${number} issue${number === 1 ? '' : 's'}:`,
  filterBlockInvalid: (block: string) => `${block} is invalid`,
  filterValuesUnsupported: (filterName: string) => `Filter values are not supported for <code>${filterName}</code>`,
  filterProviderNotSupported: (filterName: string) => `Filter '${filterName}' not supported`,
  filterProviderDeprecated: (filterName: string) =>
    `Filter '${filterName}' is deprecated and will be removed in the future`,
  filterValueEmpty: (provider: string) => `Empty value for <code>${provider}</code>`,
  filterMultiValueFalse: (provider: string) => `Only one value allowed for <code>${provider}</code>`,
  filterInvalidValue: (provider: string, value: string) =>
    `Invalid value <code>${value}</code> for <code>${provider}</code>`,
  filterProviderTopLevel: (provider: string) => `Filter <code>${provider}</code> cannot be used within groups`,
  unbalancedQuotations: 'Unbalanced quotation marks',
  unbalancedParentheses: 'Unbalanced parentheses',
  maxNestedGroups: `Maximum nested groups of ${MAX_NESTED_GROUPS} exceeded`,
  advancedFilterDialogCloseConfirmation: {
    title: 'Discard changes?',
    content: 'You have unsaved changes. Are you sure you want to discard them?',
    cancelButtonContent: 'Keep editing',
    confirmButtonContent: 'Close and discard',
  },
  filterSsoRequired: (provider: string, value: string, orgOrEnterprise: string) =>
    `Authenticate with ${orgOrEnterprise} to access <code>${value}</code> for <code>${provider}</code>`,
  exclude: 'Exclude',
  dividerValue: '%%DIVIDER%%',
}
